module.exports = __webpack_public_path__ + "img/homepage_3.91fb8688.svg";